import axios from '@_system/axios/axios.js'
export default {
	path: '/flowprogress',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getComment(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getComment', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	replyComment(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/replyComment/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	getFlowmark(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getFlowmark', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},	
	saveFlowmark(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/saveFlowmark', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},		
			
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post('flowprogress/systemListInit', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
}
